export default __webpack_public_path__ + "static/media/kayaguneri6.fd91ef07.jpg";